export const HelfoDeductibleCodes = [
    { code: 'A', desc: 'Smittefarlig sykdom' },
    { code: 'B', desc: 'Barn under 16 år' },
    { code: 'E', desc: 'Kommunalt frikort' },
    { code: 'F', desc: 'Frikort' },
    { code: 'G', desc: 'HIV-infeksjon' },
    { code: 'H', desc: 'Pasientens tilstand til hinder for avkreving av egenandel' },
    { code: 'I', desc: 'Innsatt i fengsel/sikringsanstalt' },
    { code: 'J', desc: 'Psykoterapeutisk/psykiatrisk behandling til og med det året pasienten fyller 26 år' },
    { code: 'K', desc: 'Krigsskade' },
    { code: 'M', desc: 'Militærperson, vernepliktig' },
    { code: 'R', desc: 'Behandling ved voldtektsmottak' },
    { code: 'S', desc: 'Svangerskap' },
    { code: 'Y', desc: 'Yrkesskade' },
    { code: 'W', desc: 'Legemiddelassistert rehabilitering (LAR)' },
    { code: 'HT', desc: 'Honorartakst' },
    { code: 'XK', desc: 'Krisepsykologisk behandling' }
];
